<template>
    <selectInput
        ref="selectInput"
        v-model="localValue"
        :extended="true"
        :label="label"
        :class-label="classLabel"
        :class-input="classInput"
        :name="name"
        :placeholder="placeholder"
        :required="required"
        :simple="simple"
        :multiple="multiple"
        :auto-resize="multiple"
        :disabled="disabled"
        :tag="tag"
        :options="options"
        :option-addons="optionAddons"
        :open-endpoint="openEndpoint"
        :endpoint="endpoint"
        :payload="payload"
        :before-run-endpoint="beforeRunEndpoint"
        :dd-auto-refresh="ddAutoRefresh"
        class="select-user-input"
        @update:modelValue="updateModelValue"
        @addEvent="addEventEvent"
        @beforeEnter="beforeEnterEvent"
        @afterEnter="afterEnterEvent"
        @beforeLeave="beforeLeaveEvent"
        @afterLeave="afterLeaveEvent"
        @afterScrollbarStart="afterScrollbarStartEvent"
        @afterScrollbarEnd="afterScrollbarEndEvent"
        @beforeRunEndpoint="beforeRunEndpointEvent"
        @afterRunEndpoint="afterRunEndpointEvent"
        @errorRunEndpoint="errorRunEndpointEvent"
        @selectOption="selectOptionEvent"
        @removeOption="removeOptionEvent"
        @clearOption="clearOptionEvent"
    >
        <template #selected="selProps">
            <div>
                <div class="fw-semibold">{{ selProps.item.name.toUpperCase() }}</div>
                <div>
                    <small class="lh-1-1">{{ travelAgentAddress(selProps.item) }}</small>
                </div>
                <div v-if="selProps.item.email || selProps.item.phone || selProps.item.whatsapp">
                    <small v-if="selProps.item.email" class="lh-1-1 text-muted me-1"><i class="ti ti-mail me-1"></i>{{ selProps.item.email }}</small>
                    <small v-if="selProps.item.phone" class="lh-1-1 text-muted me-1"><i class="ti ti-phone me-1"></i>{{ selProps.item.phone }}</small>
                    <small v-if="selProps.item.whatsapp" class="lh-1-1 text-muted"><i class="ti ti-brand-whatsapp me-1"></i>{{ selProps.item.whatsapp }}</small>
                </div>
            </div>
        </template>
        <template #listGroupItem="lgiProps">
            <div>
                <div class="fw-semibold">{{ lgiProps.item.name.toUpperCase() }}</div>
                <div>
                    <small class="lh-1-1">{{ travelAgentAddress(lgiProps.item) }}</small>
                </div>
                <div v-if="lgiProps.item.email || lgiProps.item.phone || lgiProps.item.whatsapp">
                    <small v-if="lgiProps.item.email" class="lh-1-1 text-muted me-1"><i class="ti ti-mail me-1"></i>{{ lgiProps.item.email }}</small>
                    <small v-if="lgiProps.item.phone" class="lh-1-1 text-muted me-1"><i class="ti ti-phone me-1"></i>{{ lgiProps.item.phone }}</small>
                    <small v-if="lgiProps.item.whatsapp" class="lh-1-1 text-muted"><i class="ti ti-brand-whatsapp me-1"></i>{{ lgiProps.item.whatsapp }}</small>
                </div>
            </div>
        </template>
    </selectInput>
</template>

<script>
import {toolbox} from "../toolbox/toolbox.js";
import {arrayHelper} from "../../utils/helpers/arrayHelper.js";

export default {
    name: "selectTravelAgent",
    components: {
        selectInput : toolbox.selectInput,
        userAvatar : toolbox.userAvatar,
    },
    props : {
        modelValue: {
            type: [null, Number, String, Array],
            default: null
        },
        label: {
            type: String,
            default: ''
        },
        classLabel: {
            type: String,
            default: 'form-label'
        },
        classInput: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Choose...'
        },
        required: {
            type: Boolean,
            default: false
        },
        simple: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tag : {
            type : Boolean,
            default : false
        },
        options: {
            type: Array,
            default: []
        },
        optionAddons: {
            type: Array,
            default: []
        },
        openEndpoint: {
            type : [null, String],
            default : null
        },
        endpoint : {
            type : [null, String],
            default : '/travel-agent'
        },
        payload : {
            type : Object,
            default : {}
        },
        beforeRunEndpoint : {
            type: [null, Function],
            default:null
        },
        ddAutoRefresh: {
            type: Boolean,
            default: false
        }
    },
    emits : [
        'addEvent',
        'beforeEnter',
        'afterEnter',
        'beforeLeave',
        'afterLeave',
        'afterScrollbarStart',
        'afterScrollbarEnd',
        'beforeRunEndpoint',
        'afterRunEndpoint',
        'errorRunEndpoint',
        'selectOption',
        'removeOption',
        'clearOption',
        'update:modelValue'
    ],
    data() {
        return {
            localValue: this.modelValue
        };
    },
    watch: {
        modelValue(newValue) {
            if (!this.writing) {
                this.localValue = newValue;
            }
            this.writing = false;
        }
    },
    methods: {
        reset() {
            this.$refs.selectInput.reset();
        },
        afterRunEndpointEvent(event) {
            setTimeout(()=>{
                this.$refs.selectInput.reinitDropdown();
            }, 5);
        },
        updateModelValue(value) {
            this.writing = true;
            this.$emit('update:modelValue', value);
        },
        addEventEvent(event) {
            this.$emit('addEvent', event);
        },
        beforeEnterEvent(event) {
            this.$emit('beforeEnter', event);
        },
        afterEnterEvent(event) {
            this.$emit('afterEnter', event);
        },
        beforeLeaveEvent(event) {
            this.$emit('beforeLeave', event);
        },
        afterLeaveEvent(event) {
            this.$emit('afterLeave', event);
        },
        afterScrollbarStartEvent(event) {
            this.$emit('afterScrollbarStart', event);
        },
        afterScrollbarEndEvent(event) {
            this.$emit('afterScrollbarEnd', event);
        },
        beforeRunEndpointEvent(event) {
            this.$emit('beforeRunEndpoint', event);
        },
        errorRunEndpointEvent(event) {
            this.$emit('errorRunEndpoint', event);
        },
        selectOptionEvent(event) {
            this.$emit('selectOption', event);
        },
        removeOptionEvent(event) {
            this.$emit('removeOption', event);
        },
        clearOptionEvent(event) {
            this.$emit('clearOption', event);
        },
        removeOption(index) {
            this.$refs.selectInput.selectItem = arrayHelper.deleteIndex(this.$refs.selectInput.selectItem, index);
            this.$refs.selectInput.selectIndex = arrayHelper.deleteIndex(this.$refs.selectInput.selectIndex, index);

            if(!this.$refs.selectInput.selectItem.length) {
                this.$refs.selectInput.selectItem = null;
                this.$refs.selectInput.selectIndex = null;
                this.updateModelValue((this.multiple?[]:null));
            } else {
                const values = [];
                this.$refs.selectInput.selectItem.forEach(item=>{
                    values.push(item.id);
                });
                this.updateModelValue(values);
            }
        },
        travelAgentAddress(item) {
            let strAddress = item.address;
            if(item.city) {
                strAddress += `, ${item.city}`;
            }
            if(item.state) {
                strAddress += ` ${item.state}`;
            }
            if(item.country) {
                strAddress += ` ${item.country}`;
            }
            if(item.zipcode) {
                strAddress += ` ${item.zipcode}`;
            }
            return strAddress;
        }
    }
}
</script>

<style scoped>

</style>
